<template>
  <iframe id="iframeExtension" :src="url" frameborder="0" @error="handleError" @load="handleLoaded"></iframe>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    datasVisiteur: {
      type: Object
    }
  },
  created () {
    if (!this.site || this.site.DSK_EXTENSION_ONOFF !== '1') {
      this.$emit('closeDialog')
    }
  },
  methods: {
    handleError (event) {
      console.warn('handleError', event)
    },
    handleLoaded (event) {
      console.warn('handleLoaded', event)
    }
  },
  computed: {
    ...mapState('_Sites', ['sites']),
    site () {
      return this.sites.find(s => s.LIC_ID === this.datasVisiteur.siteID)
    },
    url () {
      const url = this.site ? this.site.DSK_EXTENSION_URL : ''
      const regex = /(?:{{(\w+)}})+/g
      let m
      let urlWithParams = url
      while ((m = regex.exec(url)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
          regex.lastIndex++
        }
        // Remplace le symbole trouvé par la variable JS
        urlWithParams = urlWithParams.replace(m[0], this.datasVisiteur[m[1]])
      }
      return urlWithParams
    }
  }
}
</script>
<style type="text/css">
  #iframeExtension {
      width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzIframeExtension.vue